/* tslint:disable */

declare var Object: any;
export interface TutorialInterface {
  "id": string;
  "TutorialType": string;
  "TutorialData"?: any;
  "FilenameOnServer"?: string;
  "OriginalFilename"?: string;
  "Description"?: string;
  "Format"?: string;
  "Url"?: string;
  "Runtime"?: number;
  "Width"?: number;
  "Height"?: number;
  "FileSize": number;
  "ThumbnailFilename": string;
  "Metadata"?: any;
  "Categories"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class Tutorial implements TutorialInterface {
  "id": string;
  "TutorialType": string;
  "TutorialData": any;
  "FilenameOnServer": string;
  "OriginalFilename": string;
  "Description": string;
  "Format": string;
  "Url": string;
  "Runtime": number;
  "Width": number;
  "Height": number;
  "FileSize": number;
  "ThumbnailFilename": string;
  "Metadata": any;
  "Categories": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: TutorialInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tutorial`.
   */
  public static getModelName() {
    return "Tutorial";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tutorial for dynamic purposes.
  **/
  public static factory(data: TutorialInterface): Tutorial{
    return new Tutorial(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tutorial',
      plural: 'Tutorials',
      path: 'Tutorials',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "TutorialType": {
          name: 'TutorialType',
          type: 'string'
        },
        "TutorialData": {
          name: 'TutorialData',
          type: 'any'
        },
        "FilenameOnServer": {
          name: 'FilenameOnServer',
          type: 'string'
        },
        "OriginalFilename": {
          name: 'OriginalFilename',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Format": {
          name: 'Format',
          type: 'string'
        },
        "Url": {
          name: 'Url',
          type: 'string'
        },
        "Runtime": {
          name: 'Runtime',
          type: 'number',
          default: 0
        },
        "Width": {
          name: 'Width',
          type: 'number'
        },
        "Height": {
          name: 'Height',
          type: 'number'
        },
        "FileSize": {
          name: 'FileSize',
          type: 'number',
          default: 0
        },
        "ThumbnailFilename": {
          name: 'ThumbnailFilename',
          type: 'string'
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Tutorial.ts